<template>
  <div class="modern-group-management">
    <a-spin :spinning="spinning">
        <div class="d-flex flex-column min-vh-100">
            <div class="container-fluid">
                <!-- Header Section -->
                <div class="header-section">
                    <div class="page-title">
                        <h2><i class="fas fa-users"></i> 我的工作人員群組</h2>
                        <p class="subtitle">管理您的工作人員團隊</p>
                    </div>
                    <div class="action-section">
                        <b-button 
                            variant="success" 
                            @click="madeGroup" 
                            class="create-group-btn"
                            size="lg">
                            <i class="fas fa-plus"></i> 建置新群組
                        </b-button>
                    </div>
                </div>
                
                <!-- Groups Grid -->
                <div class="groups-container">
                    <div class="groups-grid">
                        <div class="group-card-wrapper" v-for="item in myData" :key="item.id">
                            <div class="group-card">
                                <!-- Card Header -->
                                <div class="card-header">
                                    <h3 class="group-title">{{ item.groupname }}</h3>
                                    <div class="group-badge">
                                        <span class="member-count">{{ item.acts_grouplist.length }}</span>
                                        <span class="member-text">成員</span>
                                    </div>
                                </div>
                                
                                <!-- Card Body -->
                                <div class="card-body">
                                    <!-- Member Count with Popover -->
                                    <div class="info-item members-info">
                                        <a-popover 
                                            placement="right" 
                                            trigger="click"
                                            overlayClassName="enhanced-members-popover">
                                            <template slot="content">
                                                <div class="members-popover-enhanced">
                                                    <div class="popover-header">
                                                        <h4>
                                                            <i class="fas fa-users"></i>
                                                            群組成員
                                                        </h4>
                                                        <div class="member-stats">
                                                            <span class="total-count">共 {{ item.acts_grouplist.length }} 人</span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="members-list-enhanced">
                                                        <div v-for="(data, index) in item.acts_grouplist" 
                                                             :key="data.id" 
                                                             class="member-item-enhanced">
                                                            <div class="member-number">
                                                                {{ index + 1 }}
                                                            </div>
                                                            <b-avatar 
                                                                :src="data.pri_url" 
                                                                variant="primary" 
                                                                :text="data.displayname" 
                                                                size="3rem" 
                                                                class="member-avatar-enhanced">
                                                            </b-avatar>
                                                            <div class="member-info-enhanced">
                                                                <div class="member-name-enhanced">
                                                                    {{ data.displayname }}
                                                                </div>
                                                                <div class="member-role" v-if="data.role">
                                                                    {{ data.role }}
                                                                </div>
                                                            </div>
                                                            <div class="member-status">
                                                                <i class="fas fa-circle" :class="{'status-online': true}"></i>
                                                            </div>
                                                        </div>
                                                        
                                                        <!-- Empty state for no members -->
                                                        <div v-if="item.acts_grouplist.length === 0" class="no-members">
                                                            <i class="fas fa-user-plus"></i>
                                                            <span>尚未加入成員</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <a-button type="link" class="member-count-btn">
                                                <i class="fas fa-users"></i>
                                                群組人數: {{ item.acts_grouplist.length }}
                                            </a-button>
                                        </a-popover>
                                    </div>
                                    
                                    <!-- Info Items -->
                                    <div class="info-item">
                                        <i class="fas fa-check-circle" :class="{'text-success': item.checked, 'text-muted': !item.checked}"></i>
                                        <span>授予點名: </span>
                                        <span class="status-badge" :class="{'status-active': item.checked, 'status-inactive': !item.checked}">
                                            {{ item.checked ? '是' : '否' }}
                                        </span>
                                    </div>
                                    
                                    <div class="info-item">
                                        <i class="fas fa-award" :class="{'text-warning': item.getscore, 'text-muted': !item.getscore}"></i>
                                        <span>是否獲得學分: </span>
                                        <span class="status-badge" :class="{'status-active': item.getscore, 'status-inactive': !item.getscore}">
                                            {{ item.getscore ? '是' : '否' }}
                                        </span>
                                    </div>
                                    
                                    <div class="info-item">
                                        <i class="fas fa-calendar-alt"></i>
                                        <span>建置日期: </span>
                                        <span class="date-text">{{ dateFormat(item.created_at) }}</span>
                                    </div>
                                </div>
                                
                                <!-- Card Actions -->
                                <div class="card-actions">
                                    <b-button 
                                        variant="outline-primary" 
                                        @click="editItems(item)" 
                                        class="action-btn edit-btn">
                                        <i class="fas fa-edit"></i> 修改
                                    </b-button>
                                    <b-button 
                                        variant="outline-danger" 
                                        @click="delItems(item)" 
                                        class="action-btn delete-btn">
                                        <i class="fas fa-trash"></i> 刪除
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Empty State -->
                    <div v-if="myData.length === 0" class="empty-state">
                        <i class="fas fa-users-slash"></i>
                        <h3>尚未建立群組</h3>
                        <p>點擊上方按鈕開始建立您的第一個工作人員群組</p>
                    </div>
                </div>
            </div>
            <div class="wrapper flex-grow-1"></div>      
        </div>

        <!-- Enhanced Modal -->
        <b-modal 
            ref="my-Groups" 
            id="modal-admin" 
            size="xl" 
            @hide="onHide" 
            centered 
            hide-footer 
            hide-header
            class="modern-modal">
            <div class="modal-content-wrapper">
                <!-- Modal Header -->
                <div class="modal-header-custom">
                    <h3 class="modal-title">
                        <i class="fas fa-users-cog"></i>
                        {{ myEditId == 0 ? '建置新群組' : '修改群組' }}
                    </h3>
                    <button type="button" class="close-btn" @click="closeModal()">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                
                <!-- Modal Body -->
                <div class="modal-body-custom">
                    <!-- Group Name Input -->
                    <div class="form-section">
                        <div class="form-group">
                            <label class="form-label">
                                <i class="fas fa-tag"></i> 義工群組名稱
                            </label>
                            <b-form-input
                                autocomplete="off"
                                v-model="groupName"
                                type="text"
                                placeholder="請輸入義工群組名稱"
                                class="modern-input"
                                size="lg">
                            </b-form-input>
                        </div>
                    </div>
                    
                    <!-- Group Settings -->
                    <div class="form-section">
                        <div class="settings-grid">
                            <div class="setting-item">
                                <div class="setting-label">
                                    <i class="fas fa-check-circle"></i>
                                    <span>授予點名</span>
                                </div>
                                <a-switch 
                                    checked-children="是" 
                                    un-checked-children="否" 
                                    @change="orderChange" 
                                    :checked="checked" 
                                    class="modern-switch" />
                            </div>
                            
                            <div class="setting-item">
                                <div class="setting-label">
                                    <i class="fas fa-award"></i>
                                    <span>是否獲得學分</span>
                                </div>
                                <a-switch 
                                    checked-children="是" 
                                    un-checked-children="否" 
                                    @change="scoreChange" 
                                    :checked="getscore" 
                                    class="modern-switch" />
                            </div>
                        </div>
                    </div>
                    
                    <!-- User Search -->
                    <div class="form-section">
                        <div class="search-section">
                            <label class="form-label">
                                <i class="fas fa-search"></i> 搜尋成員
                            </label>
                            <a-input-search 
                                placeholder="請輸入查詢名稱" 
                                class="search-input"
                                size="large"
                                enter-button="搜尋" 
                                @search="onSearch" />
                        </div>
                    </div>
                    
                    <!-- User Table -->
                    <div class="form-section">
                        <div class="table-wrapper">
                            <a-table 
                                :columns="columns"
                                :row-key="record => record.id"
                                :data-source="udata"
                                :pagination="upagination"
                                :loading="uloading"
                                :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                                @change="uhandleTableChange"
                                class="modern-table"
                                size="middle">                                                
                                <template slot="pri_url" slot-scope="pri_url"> 
                                    <b-avatar :src="pri_url" variant="primary" text="" size="2.5rem" class="table-avatar"></b-avatar>                                 
                                </template> 
                                <template slot="username" slot-scope="record">
                                    <div class="username-cell">
                                        <span v-if="record.username != ''" class="masked-name">{{ maskName(record.username) }}</span>                                   
                                    </div>
                                </template> 
                                <template slot="display_name" slot-scope="record">
                                    <div class="displayname-cell">
                                        <span v-if="record.display_name != ''" class="display-name">{{ record.display_name }}</span>                                    
                                    </div>
                                </template>                                                                                
                            </a-table>
                        </div>
                    </div>
                    
                    <!-- Selected Members Preview -->
                    <div class="form-section" v-if="selectedItems.length > 0">
                        <div class="selected-members-section">
                            <div class="selected-header">
                                <div class="header-content">
                                    <h4>
                                        <i class="fas fa-users-check"></i>
                                        已選擇的工作人員成員
                                    </h4>
                                    <div class="selected-count">
                                        <span class="count-badge">{{ selectedItems.length }}</span>
                                        <span class="count-text">位成員</span>
                                    </div>
                                </div>
                                <div class="header-actions">
                                    <a-button 
                                        size="small" 
                                        type="danger" 
                                        ghost
                                        @click="clearAllSelected"
                                        :disabled="selectedItems.length === 0">
                                        <i class="fas fa-trash-alt"></i>
                                        清空所有
                                    </a-button>
                                </div>
                            </div>
                            
                            <div class="selected-members-grid">
                                <div 
                                    v-for="member in selectedItems" 
                                    :key="member.id" 
                                    class="selected-member-card">
                                    <div class="member-card-content">
                                        <b-avatar 
                                            :src="member.pri_url" 
                                            variant="primary" 
                                            :text="member.displayname" 
                                            size="2.5rem" 
                                            class="selected-avatar">
                                        </b-avatar>
                                        <div class="member-details">
                                            <div class="member-display-name">
                                                {{ member.displayname }}
                                            </div>
                                            <div class="member-username" v-if="member.name">
                                                {{ maskName(member.name) }}
                                            </div>
                                        </div>
                                        <button 
                                            class="remove-member-btn" 
                                            @click="removeMember(member.id)"
                                            title="移除此成員">
                                            ×
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Empty Selected State -->
                    <div class="form-section" v-else>
                        <div class="empty-selected-state">
                            <i class="fas fa-user-plus"></i>
                            <h4>尚未選擇工作人員成員</h4>
                            <p>請從上方表格中勾選要加入群組的工作人員成員</p>
                        </div>
                    </div>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer-custom">
                    <a-button-group class="action-button-group">
                        <a-button 
                            size="large"
                            @click="closeModal()" 
                            :loading="loading"
                            class="cancel-btn">
                            <div class="button-content">
                                <i class="fas fa-times"></i>
                                <span>取消</span>
                            </div>
                        </a-button>                 
                        <a-button
                            type="primary"
                            size="large"
                            @click="createdGroup()"
                            :disabled="selectedRowKeys.length==0 || groupName==''"
                            :loading="loading"
                            class="submit-btn">
                            <div class="button-content">
                                <i class="fas fa-save"></i>
                                <span>{{ myEditId==0?'建置':'更新' }}</span>
                            </div>
                        </a-button>
                    </a-button-group>
                </div>
            </div>
        </b-modal>

    </a-spin>
  </div>
</template>
<script>

import router from '../../../router'
import * as moment from "moment/moment";
import { userService,cmessService } from '../../../_services'
import {mapState,mapActions} from 'vuex';

const queryData = obj => {
  return userService.myGroups(obj);
}; 

const queryName = obj => {
  return userService.queryGroupName(obj);
}; 


const postGroup = obj => {
  return userService.postGroup(obj);
}; 

const queryuser = params => {
  return cmessService.findusListName(params.page,params.name)
}

const deleteItem = obj => {
  return userService.deleteGroup(obj);
}; 



const columns = [
  {
    title: '圖像',
    dataIndex: 'pri_url',
    width: '20%',    
    scopedSlots: { customRender: 'pri_url' },    
  },       
  {
    title: '註冊帳號',
    dataIndex: '',
    scopedSlots: { customRender: 'username' },      
    width: '30%',
  },   
  {
    title: 'Line顯示名稱',
    dataIndex: '',
    scopedSlots: { customRender: 'display_name' },      
    width: '30%',
  },  

];

export default {
  name: 'MyGroup',
  components: {
  },
  data() {
    return {
        spinning: false,
        loading:false,
        uloading: false,
        upagination: {defaultPageSize:4},  
        selectedRowKeys: [],  
        groupName:'',
        isGroupNameTaken: false,
        isGroupNameAvailable: false, 
        checked:true,
        getscore:true,      
        columns,  
        name:"all",                     
        myData:[],
        udata: [],
        selectedItems: [],
        myEditId:0,
    };
  },
  watch: {
    defaultval(val) {
      console.log(val)
      this.myReload();
    }
  },
  methods:{
        ...mapActions('account',['checktoken']), 
        myReload() {
            this.spinning=true;
                queryData({id:this.defaultval.id
            }).then(({ data }) => {
                this.spinning = false; 
                if(data!==undefined){
                    this.myData = data//data.sort((a, b) => b.act - a.act);
                }
            });
        },
        query(rs){
          console.log(rs)
        }, 
        getwinsize(val){
          this.windowsize.width = val.width
          this.windowsize.height = val.height
        },
        clearItem(){
          this.selectedRowKeys=[]
          this.selectedItems=[]
          this.groupName=''
          this.checked=true
          this.getscore=true
          this.myEditId=0;
          //this.isGroupNameTaken=false
          //this.isGroupNameAvailable=false
        },
        madeGroup(){
          this.myEditId=0
          this.clearItem();
          this.$refs['my-Groups'].show()
        }, 
        closeModal(){
          this.$refs['my-Groups'].hide()
        }, 
        onHide(evt) {
            if(evt.trigger === "backdrop"){
                evt.preventDefault();
            }
        },
       async createdGroup(){
          this.loading=true;
          this.spinning=true;
          let mygroup =[];
          this.selectedItems.forEach((item) => {
            mygroup.push({
              uid: item.id,
              displayname: item.displayname,
              pri_url:item.pri_url,
              name:item.name,              
            });
          });          
          let tmp={     
            id:this.myEditId,
            groupname:this.groupName, //義工群組名稱            
            uid:this.defaultval.id,
            checked:this.checked,     //授予點名
            getscore:this.getscore,   //否獲得學分
            acts_grouplist:mygroup    //義工人員
          }

       await postGroup(tmp).then(({data}) =>{
                if(data.code==200){
                  setTimeout(() => {   
                      this.loading=false;
                      this.spinning=false;                        
                      this.clearItem();
                      this.myReload(); 
                      this.$refs['my-Groups'].hide()
                      clearInterval();
                    }, 2000);
                }
            });           
        },
        dateFormat(val){
          //return moment(val).format("YYYY-MM-DD HH:mm");
          return moment(val).format("YYYY-MM-DD"); 
        },        
        usfetch(params = {}) { 
          this.uloading = true;
          queryuser({
              //results: 4,
              ...params,
          }).then(({ data }) => {
              const pagination = { ...this.upagination };
              pagination.total = data.info.totail;
              this.uloading = false;
              this.udata = data.results;
              this.upagination = pagination;                 
          });
        },
        uhandleTableChange(pagination, filters, sorter) {
          const pager = { ...this.upagination };
          pager.current = pagination.current;
          this.upagination = pager;
          this.usfetch({
              results: pagination.pageSize,
              page: pagination.current,
              name: this.name,
              sortField: sorter.field,
              sortOrder: sorter.order,
              ...filters,
          });
        },
        async onSearch(value) {
          if(value==""){
            this.name = "all"
          }else{
            this.name = value
          }
          await this.usfetch({results:4,page:1,pageSize: 4,name: this.name});
        }, 


        onSelectChange(selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys;
          const selectedItemsMap = new Map(this.selectedItems.map(item => [item.id, item]));
          // Add new selected items
          selectedRows.forEach(row => {
            selectedItemsMap.set(row.id, {
              id: row.id,
              displayname: row.display_name,
              pri_url: row.pri_url,
              name: row.username
            });
          });
          // Remove deselected items
          this.selectedItems = Array.from(selectedItemsMap.values()).filter(item =>
            selectedRowKeys.includes(item.id)
          );
        },        
        
        // 移除單個成員
        removeMember(memberId) {
          this.selectedRowKeys = this.selectedRowKeys.filter(id => id !== memberId);
          this.selectedItems = this.selectedItems.filter(item => item.id !== memberId);
        },
        
        // 清空所有選擇
        clearAllSelected() {
          this.selectedRowKeys = [];
          this.selectedItems = [];
        },
        
        maskName(name) {
            const len = name.length;
            const half = Math.ceil(len / 2);
            const maskedPart = '*'.repeat(half);
            const visiblePart = name.slice(half);
            return maskedPart + visiblePart;
        },
        async checkGroupName() {
          if(this.groupName!==''){
            await queryName({id:this.defaultval.id,name:this.groupName
              }).then(({ data }) => {
                  this.isGroupNameTaken = data;
                  this.isGroupNameAvailable = !this.isGroupNameTaken && this.groupName !== '';                
              });
          }          
        },
        orderChange(checked) {
            this.checked = checked
        },
        scoreChange(getscore) {
            this.getscore = getscore
        },
        
        editItems(item){
          this.clearItem();
          this.myEditId=item.id;
          this.groupName=item.groupname
          this.checked=item.checked
          this.getscore=item.getscore 
          const myData = item.acts_grouplist;
          const initialSelectedIds = myData.map(item => item.uid);
          this.selectedRowKeys = initialSelectedIds;
          this.selectedItems = myData
          .filter(item => initialSelectedIds.includes(item.uid))
          .map(item => ({
            id: item.uid,
            displayname: item.displayname,
            pri_url: item.pri_url,
            name:item.name, 
          }));
          this.$refs['my-Groups'].show()
        },  
        delItems(item){
          const self = this;
          this.$confirm({
            title:
              "您確定刪除該群組?",
            content: "群組名稱 : " + item.groupname,
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            zIndex: 9999,
            async onOk() {
              self.spinning=true;
              await self.remove(item);
            },
            onCancel() {
              console.log("Cancel");
            }
          });
        },
        remove(item) {
          return new Promise((resolve) => {
              deleteItem({
              ...item //...解壓縮出來
            }).then(({ data }) => { 
              if(data.code==200){
                setTimeout(() => {
                  this.myReload(); 
                      this.spinning=false; 
                  }, 1000);                
                return resolve(true);
              }             
              return resolve(false);
            });
          })      
        }, 
    },
    computed:{
      ...mapState('account',['user']),
      ...mapState("makeorg", [ "defaultval"])
    },    
    async mounted(){ 
        if(this.user==null){
          router.replace('/')
        }else{
          this.checktoken(); 
          this.myReload();
          await this.usfetch({results:4,page:1,pageSize: 4,name: this.name});
        }
    }      
}
</script>
<style scoped>
/* Modern Group Management Styles */
.modern-group-management {
  background: #f8f9fa;
  color-scheme: light !important;
  min-height: 100vh;
  padding: 20px 0;
}

.modern-group-management * {
  color-scheme: light !important;
}

/* Header Section */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 15px;
  color: white;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}

.page-title h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: white;
}

.page-title .subtitle {
  margin: 5px 0 0 0;
  opacity: 0.9;
  font-size: 1rem;
  color: white;
}

.create-group-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-weight: 600;
  padding: 12px 24px;
  border-radius: 50px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.create-group-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

/* Groups Container */
.groups-container {
  padding: 0 15px;
}

.groups-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

/* Group Card */
.group-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.group-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.group-title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
  color: white;
}

.group-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 8px 15px;
  border-radius: 50px;
  text-align: center;
  backdrop-filter: blur(10px);
}

.member-count {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.member-text {
  font-size: 0.8rem;
  opacity: 0.9;
  color: white;
}

.card-body {
  padding: 25px;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 1rem;
}

.info-item i {
  margin-right: 12px;
  width: 20px;
  font-size: 1.1rem;
}

.members-info {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.member-count-btn {
  color: #667eea !important;
  font-weight: 600;
  padding: 0;
  text-decoration: none;
}

.member-count-btn:hover {
  color: #4CAF50 !important;
}

.status-badge {
  background: #e9ecef;
  color: #6c757d;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-left: auto;
}

.status-active {
  background: #d4edda;
  color: #155724;
}

.status-inactive {
  background: #f8d7da;
  color: #721c24;
}

.date-text {
  color: #6c757d;
  font-weight: 500;
  margin-left: auto;
}

.card-actions {
  padding: 20px 25px;
  background: #f8f9fa;
  display: flex;
  gap: 12px;
}

.action-btn {
  flex: 1;
  font-weight: 600;
  padding: 12px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  background: #007bff;
  color: white;
  transform: translateY(-1px);
}

.delete-btn:hover {
  background: #dc3545;
  color: white;
  transform: translateY(-1px);
}

/* Enhanced Members Popover */
.enhanced-members-popover {
  min-width: 450px !important;
  max-width: 500px !important;
}

.enhanced-members-popover .ant-popover-content {
  padding: 0 !important;
}

.enhanced-members-popover .ant-popover-inner {
  border-radius: 15px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
}

.members-popover-enhanced {
  width: 100%;
  background: white;
  border-radius: 15px;
  overflow: hidden;
}

.popover-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popover-header h4 {
  margin: 0;
  color: white;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.popover-header h4 i {
  margin-right: 10px;
  font-size: 1.1rem;
}

.member-stats {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.total-count {
  font-size: 0.9rem;
  font-weight: 600;
  color: white;
}

.members-list-enhanced {
  max-height: 350px;
  overflow-y: auto;
  padding: 15px;
}

.member-item-enhanced {
  display: flex;
  align-items: center;
  padding: 15px;
  margin-bottom: 12px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #f8f9fa;
  transition: all 0.3s ease;
  position: relative;
}

.member-item-enhanced:hover {
  background: #e9ecef;
  transform: translateX(3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.member-item-enhanced:last-child {
  margin-bottom: 0;
}

.member-number {
  background: #667eea;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  margin-right: 15px;
  flex-shrink: 0;
}

.member-avatar-enhanced {
  margin-right: 15px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
  border: 3px solid #fff;
  flex-shrink: 0;
}

.member-info-enhanced {
  flex: 1;
  min-width: 0;
}

.member-name-enhanced {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 4px;
  word-wrap: break-word;
  line-height: 1.3;
}

.member-role {
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}

.member-status {
  display: flex;
  align-items: center;
  margin-left: 10px;
  flex-shrink: 0;
}

.member-status .fas {
  font-size: 0.7rem;
  margin-left: 5px;
}

.status-online {
  color: #28a745;
}

.no-members {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

.no-members i {
  font-size: 2.5rem;
  margin-bottom: 15px;
  opacity: 0.5;
}

.no-members span {
  display: block;
  font-size: 1rem;
  font-weight: 500;
}

/* Scrollbar for members list */
.members-list-enhanced::-webkit-scrollbar {
  width: 6px;
}

.members-list-enhanced::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.members-list-enhanced::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.members-list-enhanced::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Legacy Members Popover (fallback) */
.members-popover {
  max-width: 350px;
}

.members-popover h4 {
  margin: 0 0 15px 0;
  color: #495057;
  font-size: 1.1rem;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 8px;
}

.members-list {
  max-height: 300px;
  overflow-y: auto;
}

.member-item {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.member-item:hover {
  background: #e9ecef;
  transform: translateX(5px);
}

.member-avatar {
  margin-right: 12px;
}

.member-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #495057;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
}

.empty-state i {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-state h3 {
  margin-bottom: 10px;
  font-size: 1.5rem;
}

/* Modal Styles */
.modern-modal .modal-dialog {
  max-width: 1200px;
}

.modal-content-wrapper {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.modal-body-custom {
  padding: 30px;
  max-height: 70vh;
  overflow-y: auto;
}

.form-section {
  margin-bottom: 30px;
}

.form-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
  font-size: 1rem;
}

.form-label i {
  margin-right: 8px;
  color: #667eea;
}

.modern-input {
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.modern-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 15px;
  border: 1px solid #e9ecef;
}

.setting-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #495057;
}

.setting-label i {
  margin-right: 8px;
  color: #667eea;
}

.search-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 15px;
  border: 1px solid #e9ecef;
}

.search-input {
  width: 100%;
}

.table-wrapper {
  background: white;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.modern-table {
  border-radius: 15px;
}

.table-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.username-cell .masked-name {
  color: #F08C3C;
  font-weight: 600;
}

.displayname-cell .display-name {
  color: #2c7190;
  font-weight: 600;
}

/* Selected Members Section */
.selected-members-section {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 15px;
  overflow: hidden;
}

.selected-header {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 20px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.header-content h4 {
  margin: 0;
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.header-content h4 i {
  margin-right: 8px;
  font-size: 1rem;
}

.selected-count {
  display: flex;
  align-items: center;
  gap: 5px;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.count-badge {
  background: white;
  color: #28a745;
  font-weight: 700;
  font-size: 1rem;
  padding: 2px 8px;
  border-radius: 12px;
  min-width: 24px;
  text-align: center;
}

.count-text {
  font-size: 0.9rem;
  color: white;
  font-weight: 500;
}

.header-actions button {
  background: rgba(255, 255, 255, 0.2) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  color: white !important;
}

.header-actions button:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.selected-members-grid {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
  max-height: 300px;
  overflow-y: auto;
}

.selected-member-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.selected-member-card:hover {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.member-card-content {
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}

.selected-avatar {
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #fff;
}

.member-details {
  flex: 1;
  min-width: 0;
}

.member-display-name {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 4px;
  word-wrap: break-word;
  line-height: 1.3;
}

.member-username {
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
}

.remove-member-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}

.remove-member-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

.remove-member-btn:active {
  transform: scale(0.95);
}

/* Empty Selected State */
.empty-selected-state {
  text-align: center;
  padding: 40px 20px;
  background: #f8f9fa;
  border: 2px dashed #e9ecef;
  border-radius: 15px;
  color: #6c757d;
}

.empty-selected-state i {
  font-size: 3rem;
  margin-bottom: 15px;
  opacity: 0.5;
  color: #28a745;
}

.empty-selected-state h4 {
  margin-bottom: 8px;
  font-size: 1.2rem;
  color: #495057;
}

.empty-selected-state p {
  margin: 0;
  font-size: 0.95rem;
  opacity: 0.8;
}

/* Scrollbar for selected members grid */
.selected-members-grid::-webkit-scrollbar {
  width: 6px;
}

.selected-members-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.selected-members-grid::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.selected-members-grid::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.modal-footer-custom {
  background: #f8f9fa;
  padding: 20px 30px;
  border-top: 1px solid #e9ecef;
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.cancel-btn {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
  font-weight: 600;
  border-radius: 10px;
  padding: 12px 24px;
}

.submit-btn {
  background: #28a745;
  border-color: #28a745;
  font-weight: 600;
  border-radius: 10px;
  padding: 12px 24px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-section {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .groups-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .settings-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .card-actions {
    flex-direction: column;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .selected-members-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .selected-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .header-content {
    flex-direction: column;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .modern-group-management {
    padding: 10px 0;
  }
  
  .groups-container {
    padding: 0 10px;
  }
  
  .modal-body-custom {
    padding: 20px;
  }
  
  .page-title h2 {
    font-size: 1.5rem;
  }
  
  .member-card-content {
    padding: 12px;
    gap: 10px;
  }
  
  .selected-avatar {
    width: 2rem !important;
    height: 2rem !important;
  }
  
  .member-display-name {
    font-size: 0.9rem;
  }
}

/* Dark mode override */
@media (prefers-color-scheme: dark) {
  .modern-group-management,
  .modern-group-management *,
  .group-card,
  .modal-content-wrapper,
  .modern-input,
  .setting-item,
  .search-section,
  .table-wrapper {
    background: white !important;
    color: #333 !important;
    color-scheme: light !important;
  }
}

/* Legacy styles for compatibility */
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

div.ex3 {
  width:800px;
  height: 460px;
  overflow: auto;
}

#style-3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: #000000;
}

#style-3 {
  text-align: left;
}

.item-container {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #eaeaea;
  border-radius: 5px;
  background-color: #f9f9f9;
}

.avatar {
  margin-right: 10px;
}

.text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.displayname {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

/* Button Group Styles */
.action-button-group {
  width: 100%;
  display: flex;
  gap: 10px;
}

.action-button-group .ant-btn {
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1;
}

.button-content i {
  font-size: 14px;
}

.button-content span {
  font-size: 16px;
  font-weight: 600;
}

.cancel-btn {
  background: #f8f9fa;
  border-color: #dee2e6;
  color: #6c757d;
}

.cancel-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #495057;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.submit-btn:disabled {
  background: #e9ecef;
  color: #6c757d;
  opacity: 0.6;
}

.modal-footer-custom {
  padding: 20px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;
  border-radius: 0 0 15px 15px;
}
</style>